import api from './api';

const vaultsourceService = {
  // Get all vaultsources with optional filters
  getAllVaultSources: async (filters = {}) => {
    const params = new URLSearchParams();

    if (filters.name) {
      params.append('name', filters.name);
    }

    const queryString = params.toString();
    const url = queryString ? `/vaultsource?${queryString}` : '/vaultsource';

    const response = await api.get(url);
    return response.data;
  },

  // Get a single vaultsource by ID
  getVaultSourceById: async (id) => {
    const response = await api.get(`/vaultsource/${id}`);
    return response.data;
  },

  // Create a new vaultsource
  createVaultSource: async (vaultsourceData) => {
    const response = await api.post('/vaultsource', vaultsourceData);
    return response.data;
  },

  // Update an existing vaultsource
  updateVaultSource: async (id, vaultsourceData) => {
    const response = await api.put(`/vaultsource/${id}`, vaultsourceData);
    return response.data;
  },

  // Delete a vaultsource
  deleteVaultSource: async (id) => {
    const response = await api.delete(`/vaultsource/${id}`);
    return response.data;
  }
};

export default vaultsourceService;
